/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CreateRouteImport } from './routes/create'
import { Route as DataRouteImport } from './routes/data'
import { Route as DeleteRouteImport } from './routes/delete'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as SignedOutRouteImport } from './routes/signed-out'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as LegalPrivacyRouteImport } from './routes/legal.privacy'
import { Route as LegalTermsRouteImport } from './routes/legal.terms'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateRoute = CreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => rootRouteImport,
} as any)
const DataRoute = DataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => rootRouteImport,
} as any)
const DeleteRoute = DeleteRouteImport.update({
  id: '/delete',
  path: '/delete',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRoute = SignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/legal/privacy',
  path: '/legal/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalTermsRoute = LegalTermsRouteImport.update({
  id: '/legal/terms',
  path: '/legal/terms',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/create': typeof CreateRoute
  '/data': typeof DataRoute
  '/delete': typeof DeleteRoute
  '/profile': typeof ProfileRoute
  '/security': typeof SecurityRoute
  '/signed-out': typeof SignedOutRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/create': typeof CreateRoute
  '/data': typeof DataRoute
  '/delete': typeof DeleteRoute
  '/profile': typeof ProfileRoute
  '/security': typeof SecurityRoute
  '/signed-out': typeof SignedOutRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/create': typeof CreateRoute
  '/data': typeof DataRoute
  '/delete': typeof DeleteRoute
  '/profile': typeof ProfileRoute
  '/security': typeof SecurityRoute
  '/signed-out': typeof SignedOutRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/create'
    | '/data'
    | '/delete'
    | '/profile'
    | '/security'
    | '/signed-out'
    | '/auth/callback'
    | '/legal/privacy'
    | '/legal/terms'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/create'
    | '/data'
    | '/delete'
    | '/profile'
    | '/security'
    | '/signed-out'
    | '/auth/callback'
    | '/legal/privacy'
    | '/legal/terms'
  id:
    | '__root__'
    | '/'
    | '/create'
    | '/data'
    | '/delete'
    | '/profile'
    | '/security'
    | '/signed-out'
    | '/auth/callback'
    | '/legal/privacy'
    | '/legal/terms'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CreateRoute: typeof CreateRoute
  DataRoute: typeof DataRoute
  DeleteRoute: typeof DeleteRoute
  ProfileRoute: typeof ProfileRoute
  SecurityRoute: typeof SecurityRoute
  SignedOutRoute: typeof SignedOutRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalTermsRoute: typeof LegalTermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create': {
      id: '/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data': {
      id: '/data'
      path: '/data'
      fullPath: '/data'
      preLoaderRoute: typeof DataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delete': {
      id: '/delete'
      path: '/delete'
      fullPath: '/delete'
      preLoaderRoute: typeof DeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-out': {
      id: '/signed-out'
      path: '/signed-out'
      fullPath: '/signed-out'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/legal/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/terms': {
      id: '/legal/terms'
      path: '/legal/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CreateRoute: CreateRoute,
  DataRoute: DataRoute,
  DeleteRoute: DeleteRoute,
  ProfileRoute: ProfileRoute,
  SecurityRoute: SecurityRoute,
  SignedOutRoute: SignedOutRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalTermsRoute: LegalTermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
